import { Heading, Link, Spacer, useToast, VStack } from '@chakra-ui/react';
import { useLoginExClient } from '@partiu/api/auth/hooks';
import { useForm } from 'react-hook-form';
import { LuMoveRight } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../../packages/ui/components/atoms/Button';
import { CPFCNPJInput } from '../../../../../../packages/ui/components/atoms/Input';
import { SectionTitle } from '../../../../../../packages/ui/components/atoms/Title';
import { useProfile } from '../../../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../../../../../../packages/ui/contexts/ThemeProvider';

export function LoginExClient({
  isNative,
  setExClient,
}: {
  isNative: boolean;
  setExClient?: (value: boolean) => void;
}) {
  const navigate = useNavigate();
  const toast = useToast({ isClosable: true });
  const { name, colors, reloadTheme } = useTheme();
  const { updateProfile } = useProfile();

  const { register, handleSubmit } = useForm();

  const loginMutation = useLoginExClient({
    onSuccess() {
      updateProfile({});
      navigate('/');
      reloadTheme();
    },
    onError(error) {
      toast({ title: 'Oops!', description: error, status: 'error' });
    },
  });

  return (
    <VStack w={'100%'} align={'flex-start'} spacing={2}>
      <SectionTitle fontSize={14} fontWeight={600}></SectionTitle>
      <Heading
        paddingTop={'20px'}
        paddingBottom={'10px'}
        fontWeight={500}
        letterSpacing={'-0.2rem'}
        fontFamily={'Montserrat'}
        fontSize={'38px'}
      >
        Login
      </Heading>
      <form
        onSubmit={handleSubmit(({ cpf }) => loginMutation.mutate({ cpf: cpf.replace(/[^a-zA-Z0-9]/g, '') }))}
        style={{ width: '100%' }}
      >
        <VStack w={'100%'} spacing={7}>
          <CPFCNPJInput {...register('cpf')} noOptions={isNative} />

          <Heading
            alignSelf={'flex-end'}
            cursor={'pointer'}
            onClick={() => {
              if (toast.isActive('password-recovery')) return;

              toast({
                id: 'password-recovery',
                title: 'Recuperação de Senha',
                description: `Para recuperar a senha da sua conta entre em contato com a ${name}.`,
              });
            }}
            textDecor={'underline'}
            fontWeight={500}
            fontSize={'14px'}
            marginTop={'-20px'}
          >
            Esqueci minha senha
          </Heading>

          <Button type="submit" isLoading={loginMutation.isLoading} rightIcon={<LuMoveRight fontSize={'24px'} />}>
            Entrar
          </Button>
          <Link
            onClick={() => {
              setExClient && setExClient(false);
            }}
            margin={'auto'}
            color={colors.primaryColor}
          >
            Voltar
          </Link>
        </VStack>
      </form>
      <Spacer />
    </VStack>
  );
}
